import {
  CreateDateColumn,
  UpdateDateColumn,
  DeleteDateColumn,
  Entity,
  Index,
  Column,
  RelationId,
  ManyToOne,
  PrimaryGeneratedColumn
} from 'typeorm'
import { ObjectType, Field, ID } from 'type-graphql'

import { Domain, ScalarObject } from '@things-factory/shell'
import { User } from '@things-factory/auth-base'

export interface ThemeType {
  name: string
  propType: string
}

var ThemeTypes: { [name: string]: ThemeType } = {
  Legend: {
    name: 'Legend',
    propType: 'legend'
  }
}

@Entity()
@Index('ix_theme_0', (theme: Theme) => [theme.domain, theme.name, theme.deletedAt], { unique: true })
@ObjectType({ description: 'Represents a visual theme or style that can be applied to dashboard components.' })
export class Theme {
  static registerThemeType(themeType: ThemeType) {
    ThemeTypes[themeType.name] = themeType
  }

  static getThemeType(name: string) {
    return ThemeTypes[name]
  }

  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID, { description: 'Unique identifier for the theme.' })
  readonly id: string

  @ManyToOne(type => Domain)
  @Field(type => Domain, { description: 'The domain to which this theme belongs.' })
  domain?: Domain

  @RelationId((theme: Theme) => theme.domain)
  domainId?: string

  @Column()
  @Field({ nullable: true, description: 'The name of the theme.' })
  name?: string

  @Column({ nullable: true })
  @Field({ nullable: true, description: 'A detailed description of the theme.' })
  description?: string

  @Column({ nullable: true })
  @Field({ nullable: true, description: 'Indicates whether the theme is currently active and available for use.' })
  active: boolean

  @Column({ nullable: true })
  @Field({ nullable: true, description: 'The type of the theme (e.g., Legend).' })
  type?: string

  @Column('simple-json', { nullable: true })
  @Field(type => ScalarObject, {
    nullable: true,
    description: 'A JSON object containing the theme-specific style values.'
  })
  value?: any

  @CreateDateColumn()
  @Field({ nullable: true, description: 'The timestamp when the theme was created.' })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true, description: 'The timestamp when the theme was last updated.' })
  updatedAt?: Date

  @DeleteDateColumn()
  @Field({ nullable: true, description: 'The timestamp when the theme was soft-deleted.' })
  deletedAt?: Date

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true, description: 'The user who created the theme.' })
  creator?: User

  @RelationId((theme: Theme) => theme.creator)
  creatorId?: string

  @ManyToOne(type => User, { nullable: true })
  @Field(type => User, { nullable: true, description: 'The user who last updated the theme.' })
  updater?: User

  @RelationId((theme: Theme) => theme.updater)
  updaterId?: string
}
